module.exports = __webpack_public_path__ + "static/shoper-5fd26ef586d42ea8fb6f1652fa61ea47.svg";